document.addEventListener('DOMContentLoaded', () => {
  const galleries = document.querySelectorAll('media-gallery');

  galleries.forEach((gallery) => {
    const slider = gallery.querySelector('ul.thumbnail-list');

    if (!slider) return;

    /*
     * ============================================================
     * 1. ЗАБРАНЯВАМЕ DRAG / WHEEL НА THUMBNAIL SLIDER
     * ============================================================
     */

    slider.addEventListener('dragstart', (e) => {
      e.preventDefault();
    });

    slider.addEventListener('mousedown', (e) => {
      if (e.target.closest('.thumbnail-list__item')) return;
      e.preventDefault();
    });

  slider.addEventListener(
      'wheel',
      (e) => {
        e.preventDefault();
        // Пренасочваме скрола да движи цялата страница нагоре/надолу вместо миниатюрите
        window.scrollBy({
          top: e.deltaY,
          behavior: 'auto'
        });
      },
      { passive: false }
    );

    /*
     * ============================================================
     * 2. ФУНКЦИЯ ЗА АКТУАЛИЗИРАНЕ НА СТРЕЛКИТЕ
     * ============================================================
     */

    function updateThumbnailButtons() {
      const items = Array.from(
        slider.querySelectorAll('.thumbnail-list__item')
      );

      if (!items.length) return;

      const previousButton = gallery.querySelector(
        'button[name="previous"], .slider-button--prev'
      );

      const nextButton = gallery.querySelector(
        'button[name="next"], .slider-button--next'
      );

      if (!previousButton && !nextButton) return;

      const maxScroll = Math.max(
        0,
        slider.scrollWidth - slider.clientWidth
      );

      const currentScroll = slider.scrollLeft;

      /*
       * Първи thumbnail
       */
      const atStart = currentScroll <= 1;

      /*
       * Последен thumbnail / край на slider-а
       *
       * Използваме реалната позиция на последния thumbnail,
       * а не фиксирана стойност.
       */
      const lastItem = items[items.length - 1];

      const lastItemRight =
        lastItem.offsetLeft + lastItem.offsetWidth;

      const atEnd =
        currentScroll + slider.clientWidth >= lastItemRight - 1 ||
        currentScroll >= maxScroll - 1;

      if (previousButton) {
        previousButton.disabled = atStart;
        previousButton.setAttribute(
          'aria-disabled',
          atStart ? 'true' : 'false'
        );
      }

      if (nextButton) {
        nextButton.disabled = atEnd;
        nextButton.setAttribute(
          'aria-disabled',
          atEnd ? 'true' : 'false'
        );
      }
    }

    /*
     * ============================================================
     * 3. АКТУАЛИЗИРАМЕ СТРЕЛКИТЕ ПРИ SCROLL
     * ============================================================
     */

    slider.addEventListener('scroll', () => {
      requestAnimationFrame(updateThumbnailButtons);
    });

    /*
     * ============================================================
     * 4. АКТУАЛИЗИРАМЕ ПРИ RESIZE
     * ============================================================
     */

    window.addEventListener('resize', () => {
      updateThumbnailButtons();
    });

    /*
     * ============================================================
     * 5. ПРИ КЛИК НА THUMBNAIL НЕ ПОЗВОЛЯВАМЕ
     *    ДА СЕ ПРОМЕНЯ ПОЗИЦИЯТА НА SLIDER-А
     * ============================================================
     */

    slider.addEventListener('click', (e) => {
      const thumb = e.target.closest('.thumbnail-list__item');

      if (!thumb) return;

      const currentScroll = slider.scrollLeft;

      requestAnimationFrame(() => {
        slider.scrollLeft = currentScroll;
        updateThumbnailButtons();
      });
    });

    /*
     * ============================================================
     * 6. СТРЕЛКИ
     * ============================================================
     */

    gallery.addEventListener(
      'click',
      (e) => {
        const btn = e.target.closest(
          'button[name="previous"], ' +
          'button[name="next"], ' +
          '.slider-button'
        );

        if (!btn) return;

        /*
         * Проверяваме дали това действително е стрелка
         */
        const isNext =
          btn.name === 'next' ||
          btn.classList.contains('slider-button--next');

        const isPrevious =
          btn.name === 'previous' ||
          btn.classList.contains('slider-button--prev');

        if (!isNext && !isPrevious) return;

        e.preventDefault();
        e.stopPropagation();

        const items = Array.from(
          slider.querySelectorAll('.thumbnail-list__item')
        );

        if (!items.length) return;

        /*
         * --------------------------------------------------------
         * Намираме thumbnail-а, който е най-близо до текущата
         * позиция.
         *
         * Няма хардкоднат gap.
         * Няма хардкодната ширина.
         * --------------------------------------------------------
         */

        const currentScroll = slider.scrollLeft;

        let currentIndex = 0;
        let smallestDistance = Infinity;

        items.forEach((item, index) => {
          const distance = Math.abs(
            item.offsetLeft - currentScroll
          );

          if (distance < smallestDistance) {
            smallestDistance = distance;
            currentIndex = index;
          }
        });

        /*
         * --------------------------------------------------------
         * Следващ / предишен thumbnail
         * --------------------------------------------------------
         */

        let targetIndex = currentIndex;

        if (isNext) {
          targetIndex = Math.min(
            currentIndex + 1,
            items.length - 1
          );
        }

        if (isPrevious) {
          targetIndex = Math.max(
            currentIndex - 1,
            0
          );
        }

        const targetItem = items[targetIndex];

        if (!targetItem) return;

        /*
         * --------------------------------------------------------
         * Изчисляваме позицията само от реалните координати
         * --------------------------------------------------------
         */

        let targetScroll = targetItem.offsetLeft;

        /*
         * Ако е последният thumbnail,
         * поставяме го в края на видимата зона.
         *
         * Това използва реалната ширина на slider-а
         * и реалната ширина на thumbnail-а.
         */

        if (targetIndex === items.length - 1) {
          targetScroll =
            targetItem.offsetLeft +
            targetItem.offsetWidth -
            slider.clientWidth;
        }

        /*
         * Ограничаваме до реалния scroll range.
         */

        const maxScroll = Math.max(
          0,
          slider.scrollWidth - slider.clientWidth
        );

        targetScroll = Math.max(
          0,
          Math.min(targetScroll, maxScroll)
        );

        /*
         * --------------------------------------------------------
         * Преместване
         * --------------------------------------------------------
         */

        slider.scrollTo({
          left: targetScroll,
          behavior: 'smooth',
        });

        /*
         * --------------------------------------------------------
         * След приключване на smooth scroll-а проверяваме
         * стрелките отново.
         * --------------------------------------------------------
         */

        setTimeout(() => {
          updateThumbnailButtons();
        }, 350);
      },
      true
    );

    /*
     * ============================================================
     * 7. ПЪРВОНАЧАЛНО СЪСТОЯНИЕ
     * ============================================================
     */

    requestAnimationFrame(() => {
      updateThumbnailButtons();
    });
  });
});